<template>
  <div class="container">
    <img class="bgImg" style="margin-top: -1px;" :src="imgSrc" alt="" />
  </div>
</template>
<script>
export default {
  name: "ImageView",
  data() {
    return {
      imgSrc: "",
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
  },
  created() {
      const query = this.$route.query;
      this.imgSrc = query.url;
  },
  methods: {
  },
};
</script>

<style scoped>
.container {
  margin: 0;
  padding: 0;
}

.bgImg {
  width: 100%;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/ImageView.vue